import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { BellRing, X, Share } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { pushSupported, isIOS, isStandalone, subscribePush, enablePush } from '../lib/push';

const DISMISS_KEY = 'push_banner_dismissed_at';

export const PushEnableBanner = () => {
  const { user } = useAuth();
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const iosNeedsInstall = isIOS() && !isStandalone();

  useEffect(() => {
    if (!user) return;
    if (pushSupported() && Notification.permission === 'granted') {
      subscribePush().catch(() => {});
      return;
    }
    const last = Number(localStorage.getItem(DISMISS_KEY) || 0);
    const denied = pushSupported() && Notification.permission === 'denied';
    if (!denied && (pushSupported() || iosNeedsInstall) && Date.now() - last > 3 * 86400000) setShow(true);
  }, [user, iosNeedsInstall]);

  if (!show) return null;
  const dismiss = () => { localStorage.setItem(DISMISS_KEY, String(Date.now())); setShow(false); };
  const activate = async () => {
    setBusy(true);
    try { await enablePush(); toast.success('Notificações ativas neste dispositivo'); setShow(false); } catch (e) {
      toast.error(e.message === 'Permissão recusada' ? 'Permissão recusada. Ative as notificações nas definições do navegador.' : 'Não foi possível ativar as notificações');
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:w-96 z-[60] rounded-2xl bg-[#2D3E6F] text-white shadow-2xl p-4 animate-in slide-in-from-bottom-4 duration-300" data-testid="push-enable-banner">
      <button type="button" onClick={dismiss} className="absolute top-3 right-3 text-white/60 hover:text-white" data-testid="push-banner-dismiss"><X className="w-4 h-4" /></button>
      <div className="flex gap-3">
        <span className="w-10 h-10 rounded-full bg-white/15 flex items-center justify-center shrink-0"><BellRing className="w-5 h-5" /></span>
        <div className="pr-4">
          <p className="font-semibold text-sm">Receber avisos no telefone</p>
          {iosNeedsInstall ? (
            <p className="text-xs text-white/80 mt-1" data-testid="push-ios-instructions">
              No iPhone: toque em <Share className="inline w-3.5 h-3.5" /> Partilhar → "Adicionar ao ecrã principal". Depois abra o CRM pelo ícone e ative aqui as notificações.
            </p>
          ) : (
            <>
              <p className="text-xs text-white/80 mt-1">Contactos agendados, leads novas e todos os avisos do CRM, mesmo com o CRM fechado.</p>
              <button type="button" disabled={busy} onClick={activate} className="mt-3 bg-white text-[#2D3E6F] text-xs font-semibold rounded-full px-4 py-2 hover:bg-slate-100 transition-colors disabled:opacity-60" data-testid="push-enable-btn">
                {busy ? 'A ativar…' : 'Ativar notificações'}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
